module.exports = __webpack_public_path__ + "img/platform-side.f6bc87cf.png";